/* eslint-disable */
export default {
  to: 'Aan',
  enterNameOrNumber: 'Naam of nummer invoeren',
} as const;

// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter name or number"@#@
